import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from './ClientReportContainer.styles';

export const ClientReportContainer = () => {
  return (
    <Container>
      <Outlet />
    </Container>
  );
};
